import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../UI';
import { Button } from '../../UI/base/Button';
import modalStyles from '../../UI/Modal.module.css';
import styles from './BookingFormModal.module.css';

// Every booking form modal is the same shell — title, fixed width, cancel/save footer — around a
// scrollable body. Only the title key prefix and the body content differ per booking type.
const MODAL_WIDTH = 640;

interface BookingFormModalShellProps {
  /** i18n key prefix; resolves to `${keyPrefix}-edit` / `${keyPrefix}-create` for the title. */
  keyPrefix: string;
  isEditing: boolean;
  onSave: () => void;
  onClose: () => void;
  children: ReactNode;
}

export const BookingFormModalShell = ({
  keyPrefix,
  isEditing,
  onSave,
  onClose,
  children
}: BookingFormModalShellProps) => {
  const { t } = useTranslation();

  const footer = (
    <div className={modalStyles.footerRow}>
      <Button type="secondary" onClick={onClose}>
        {t('save-modal-cancel')}
      </Button>
      <Button type="primary" onClick={onSave}>
        {t('config-iv-save')}
      </Button>
    </div>
  );

  return (
    <Modal
      title={t(isEditing ? `${keyPrefix}-edit` : `${keyPrefix}-create`)}
      onClose={onClose}
      width={MODAL_WIDTH}
      footer={footer}
    >
      <div className={styles.form}>{children}</div>
    </Modal>
  );
};
